<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="640px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="证书编号："
        prop="certNo">
        <el-input v-model="info.certNo"></el-input>
      </el-form-item>
      <el-form-item
        label="证书文件："
        prop="certFile">
        <upload-with-crop
          v-model="info.certFile"
          :isLt2M="2048"
          :limit="1"
          :autoCropWidth="160"
          :autoCropHeight="160"></upload-with-crop>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import UploadWithCrop from '../../components/public/upload-with-crop.vue'
export default {
  name: 'EditCertModal',
  components: { UploadWithCrop },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        identificationCertId: null,
        certNo: '',
        certFile: []
      },
      rules: {
        certNo: [
          { required: true, message: '请输入证书编号', trigger: 'blur' }
        ],
        certFile: [
          { required: true, message: '请上传证书文件', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    title() {
      const identificationCertId = this.info.identificationCertId
      return (identificationCertId ? '编辑' : '新增') + '证书'
    },
    serviceProvinceCode() {
      return this.info.area[0] || null
    },
    serviceCityCode() {
      return this.info.area[1] || null
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        identificationCertId: null,
        certNo: '',
        certFile: []
      }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.identificationCertId
            ? 'updateidentificationcert'
            : 'addidentificationcert'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.info,
              certFile: this.info.certFile.map(i => i.url).join(',')
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.$message.success('保存成功')
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    add() {
      this.toggleModal(true)
    },
    update(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
